import { j as ye } from "./jsx-runtime-3tyXYecC.mjs";
import { _ as p } from "./composeRefs-YONvD-rx.mjs";
import { useRef as x, useImperativeHandle as M } from "react";
import { useController as De } from "react-hook-form";
import { z as we, d as ve, c as xe, b as Se, u as Ee } from "./date-picker-utils-provider-CwC1AjFc.mjs";
import "./lodash-5ofSKtz3.mjs";
import { g as je, D as Ve } from "./date-picker-range-1KaSlHL8.mjs";
import { g as s } from "./get-aria-describedby-G1wcWKF2.mjs";
import { t as qe } from "./toggle-rhf-rules-Z1TdwfO9.mjs";
import { c as Y } from "./combine-function-calls-C5qD-ZYI.mjs";
import { e as c } from "./extract-rhf-validation-rule-value-DyB3XAHu.mjs";
function Qe(a, {
  endDate: e,
  endRequired: t = !1,
  endInputValue: i = "",
  getDateDisabled: o,
  maxDate: h,
  maxRangeSpanYears: n,
  minDate: u,
  required: Q = !1,
  startDate: R,
  startInputValue: S = "",
  startRequired: E = !1,
  validateDisabledDatesWithinRange: y = !1
}) {
  const F = R ? a.parseISO(R) : void 0, W = e ? a.parseISO(e) : void 0, j = u ? a.parseISO(u) : void 0, _ = h ? a.parseISO(h) : void 0;
  return we(
    a,
    F,
    W,
    S,
    i,
    Q,
    E,
    t,
    y,
    j || xe(a),
    _ || ve(a),
    je(n, y),
    typeof o == "function" ? (A) => o(Se(a, A)) : () => !1
  );
}
function $e(a) {
  return Object.entries(a).reduce(
    (e, [t, i]) => (typeof i == "object" && (e[t] = i.message), typeof i == "string" && ["required", "startRequired", "endRequired"].includes(t) && (e[t] = i), e),
    {}
  );
}
const G = {
  afterMax: window.jQuery ? $.__("Please select a start date before the maximum date.") : "Please select a start date before the maximum date.",
  beforeMin: window.jQuery ? $.__("Please select a start date after the minimum date.") : "Please select a start date after the minimum date.",
  disabled: window.jQuery ? $.__("This start date isn't available. Please choose another date.") : "This start date isn't available. Please choose another date.",
  invalid: window.jQuery ? $.__("We can't recognize this date.") : "We can't recognize this date.",
  required: window.jQuery ? $.__("Please add a start date.") : "Please add a start date."
}, H = {
  afterMax: window.jQuery ? $.__("Please select an end date before the maximum date.") : "Please select an end date before the maximum date.",
  beforeMin: window.jQuery ? $.__("Please select an end date after the minimum date.") : "Please select an end date after the minimum date.",
  disabled: window.jQuery ? $.__("This end date isn't available. Please choose another date.") : "This end date isn't available. Please choose another date.",
  invalid: window.jQuery ? $.__("We can't recognize this date.") : "We can't recognize this date.",
  required: window.jQuery ? $.__("Please add an end date.") : "Please add an end date."
}, q = {
  includesDisabled: window.jQuery ? $.__("This range includes dates that aren't available.") : "This range includes dates that aren't available.",
  invalid: window.jQuery ? $.__("Start date needs to be earlier than end date.") : "Start date needs to be earlier than end date.",
  required: window.jQuery ? $.__("We need both dates to create a range.") : "We need both dates to create a range.",
  tooLarge: window.jQuery ? $.__("Please choose a shorter date range.") : "Please choose a shorter date range."
};
function Fe(a, e) {
  if (a) {
    if (a.error === "required" && a.type === "start" && (e != null && e.startRequired))
      return e == null ? void 0 : e.startRequired;
    if (a.error === "required" && a.type === "end" && (e != null && e.endRequired))
      return e == null ? void 0 : e.endRequired;
    if (a.error === "required" && (e != null && e.required))
      return e == null ? void 0 : e.required;
    if (a.error === "afterMax" && (e != null && e.maxDate))
      return e == null ? void 0 : e.maxDate;
    if (a.error === "beforeMin" && (e != null && e.minDate))
      return e == null ? void 0 : e.minDate;
    if (a.error === "tooLarge" && (e != null && e.maxRangeSpanYears))
      return e == null ? void 0 : e.maxRangeSpanYears;
    if (a.error === "disabled" && (e != null && e.validateDisabledDatesWithinRange))
      return e == null ? void 0 : e.validateDisabledDatesWithinRange;
  }
}
function We(a, e) {
  if (!a)
    return;
  const t = Fe(a, e);
  if (t)
    return t;
  switch (a.type) {
    case "start":
      return a.error && G[a.error] || G.invalid;
    case "end":
      return a.error && H[a.error] || H.invalid;
    case "range":
      return a.error && q[a.error] || q.invalid;
    default:
      return q.invalid;
  }
}
function Ae(a, e) {
  return !a || typeof a != "object" ? {} : Object.entries(a).reduce((t, [i, o]) => (typeof o == "function" && (t[i] = (h) => (e(), o(h))), t), {});
}
function Ue({
  apiRef: a,
  containerRef: e,
  control: t,
  defaultValue: i = { endValue: "", startValue: "" },
  disabled: o,
  endAriaDescribedby: h,
  endInputProps: n = {},
  endRequired: u = !1,
  endStatus: Q,
  errorMessageId: R,
  getDateDisabled: S,
  maxDate: E,
  minDate: y,
  name: F,
  onBlur: W,
  onChange: j,
  required: _ = !1,
  shouldUnregister: A,
  startAriaDescribedby: ee,
  startInputProps: d = {},
  maxRangeSpanYears: B,
  startRequired: V = !1,
  startStatus: ae,
  validate: T,
  validateDisabledDatesWithinRange: L,
  ...te
}) {
  var Z, g, I;
  const N = c(typeof _ == "string" ? !!_ : _), k = c(typeof u == "string" ? !!u : u), U = c(E), m = c(y), J = c(B), K = c(
    typeof V == "string" ? !!V : V
  ), X = c(L), ne = Ee(), D = x(), C = x(), z = x(null), O = x(null), re = {
    dateRange: ({ startValue: r, endValue: b }) => {
      var f, P;
      const l = Qe(ne, {
        endDate: b,
        endInputValue: (f = z.current) == null ? void 0 : f.value,
        endRequired: k ?? !1,
        getDateDisabled: S,
        maxDate: U,
        maxRangeSpanYears: J,
        minDate: m,
        required: N,
        startDate: r,
        startInputValue: (P = O.current) == null ? void 0 : P.value,
        startRequired: K,
        validateDisabledDatesWithinRange: X
      });
      if (D.current = l, l) {
        const be = $e({
          endRequired: u,
          maxDate: E,
          maxRangeSpanYears: B,
          minDate: y,
          required: _,
          startRequired: V,
          validateDisabledDatesWithinRange: L
        });
        return We(l, be);
      }
    },
    ...Ae(typeof T == "function" ? { custom: T } : T, () => {
      D.current = void 0;
    })
  }, { field: ie, fieldState: w } = De({
    control: t,
    defaultValue: i,
    name: F,
    rules: qe({ validate: re }, o),
    shouldUnregister: A
  }), { onBlur: de, onChange: le, ref: fe, value: oe } = ie, { startValue: ue, endValue: ce } = oe, v = x(null);
  M(
    a,
    () => ({
      focusEnd: () => {
        var r;
        return (r = v.current) == null ? void 0 : r.focusEnd();
      },
      focusStart: () => {
        var r;
        return (r = v.current) == null ? void 0 : r.focusStart();
      }
    }),
    []
  ), M(
    fe,
    () => ({
      focus: () => {
        var l, f;
        const { current: r } = D, { type: b } = r || {};
        if (b === "end" || b !== "start" && C.current === "end") {
          (l = v.current) == null || l.focusEnd();
          return;
        }
        (f = v.current) == null || f.focusStart();
      }
    }),
    []
  );
  function he(r) {
    const { startValue: b, endValue: l } = r, f = {
      endValue: l || "",
      startValue: b || ""
    };
    le(f), typeof j == "function" && j(f);
  }
  function Re() {
    C.current = "start";
  }
  function _e() {
    C.current = "end";
  }
  return /* @__PURE__ */ ye.jsx(
    Ve,
    {
      ...te,
      apiRef: v,
      endAriaDescribedby: s(w.error ? R : void 0, h),
      endInputProps: {
        ...n,
        onFocus: Y(n == null ? void 0 : n.onFocus, _e),
        ref: n != null && n.ref ? p(n == null ? void 0 : n.ref, z) : z
      },
      endRequired: k,
      endStatus: w.error && ((Z = D.current) == null ? void 0 : Z.type) !== "start" ? "error" : Q,
      endValue: ce,
      errorMessage: R || (g = w.error) == null ? void 0 : g.message,
      getDateDisabled: S,
      maxDate: U,
      maxRangeSpanYears: J,
      minDate: m,
      onBlur: Y(de, W),
      onChange: he,
      ref: e,
      required: N,
      startAriaDescribedby: s(w.error ? R : void 0, ee),
      startInputProps: {
        ...d,
        onFocus: Y(d == null ? void 0 : d.onFocus, Re),
        ref: d != null && d.ref ? p(d == null ? void 0 : d.ref, O) : O
      },
      startRequired: K,
      startStatus: w.error && ((I = D.current) == null ? void 0 : I.type) !== "end" ? "error" : ae,
      startValue: ue,
      validateDisabledDatesWithinRange: X
    }
  );
}
export {
  Ue as D
};
//# sourceMappingURL=date-picker-range-rhf-DGVg5aov.mjs.map
